import { baseSize } from '@issuu/ixu';
import * as React from 'react';
const mapTypeToMargin = (spacingType) => {
    const baseSizePx = parseInt(baseSize.replace('px', ''), 10);
    switch (spacingType) {
        case 'small':
            return `${baseSizePx / 2}px`;
        case 'normal':
            return `${baseSizePx}px`;
        case 'large':
            return `${baseSizePx * 2}px`;
        case 'none':
            return 0;
        default:
            return null;
    }
};
const withSpacing = (Component) => ({ spacing, spacingVertical, spacingHorizontal, spacingLeft, spacingRight, spacingTop, spacingBottom, ...props }) => {
    const spacings = {
        top: spacingTop || spacingVertical || spacing,
        right: spacingRight || spacingHorizontal || spacing,
        bottom: spacingBottom || spacingVertical || spacing,
        left: spacingLeft || spacingHorizontal || spacing,
    };
    const margins = {
        top: mapTypeToMargin(spacings.top),
        right: mapTypeToMargin(spacings.right),
        bottom: mapTypeToMargin(spacings.bottom),
        left: mapTypeToMargin(spacings.left),
    };
    const style = {
        marginTop: margins.top,
        marginRight: margins.right,
        marginBottom: margins.bottom,
        marginLeft: margins.left,
    };
    if (margins.top || margins.right || margins.bottom || margins.left) {
        return React.createElement(Component, { ...props, style: style });
    }
    return React.createElement(Component, { ...props });
};
export default withSpacing;
//# sourceMappingURL=index.js.map